import { render, staticRenderFns } from "./HeaderMainMenu.vue?vue&type=template&id=4e5d37a7"
import script from "./HeaderMainMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMainMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMainMenu.vue?vue&type=style&index=0&id=4e5d37a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports